<template>
    <Popover>
        <PopoverTrigger class="flex items-stretch">
            <Badge variant="warning">
                <i class="fas fa-globe fa-lg"></i>
                <span>{{ $t("Global.Tariff") }}</span>
            </Badge>
        </PopoverTrigger>
        <PopoverContent class="p-0 w-[30rem]" :align="'start'" hide-when-detached>
            <p class="text-lg font-bold m-2">{{ $t("Global.Tariff") }}</p>
            <div class="py-2.5 px-2">
                <p class="text-sm">
                    {{ $t("Global.TariffToolTip") }}
                </p>
            </div>
        </PopoverContent>
    </Popover>
</template>
